<app-generic-container>
  <!-- Usamos el panel genérico -->
  <app-generic-panel [title]="'Configuración de valores predeterminados'" [description]="" [awesomeIcon]="'cog'">

    <div *ngIf="!conectiaLicence" class="button-container button-conectia">
      <div>
        <button class="btn btn-fill btn-primary float-right conectia-button" type="button"
          (click)="showConectiaPopUp()">
          <fa-icon icon="server" size="1x" class='mr-2 conectia-icon'></fa-icon>
          <span>Conectar Conectia</span>
        </button>
      </div>
    </div>

    <form class="form-horizontal ng-untouched ng-pristine ng-valid" (ngSubmit)="onSubmit()" #appEnvironmentEdit="ngForm"
      novalidate="">
      <div class="row">
        <div class="col-sm-12 col-lg-6">
          <div class="row">

            <div class="col-12 ml-5" *ngIf="livesHrLicence">
              <div class="block">
                <legend class="pl-0 mt-2">Mensajes de comunicación de notificaciones</legend>
                <app-form-input-app [labelText]="'Texto notificación de solicitud aceptada'" [isRequired]="true"
                  [length]="11">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.pushAcceptText"
                    (ngModelChange)="setPushAccept($event)" name="PushNotificationAccepted" required maxlength="100">
                </app-form-input-app>
                <app-form-input-app [labelText]="'Texto notificación de solicitud rechazada'" [isRequired]="true"
                  [length]="11">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.pushDenyText"
                    (ngModelChange)="setPushReject($event)" name="PushNotificationRejected" required maxlength="100">
                </app-form-input-app>
              </div>
            </div>
            <div class="col-12 ml-2 mt-4"  *ngIf="livesHrLicence">
              <dx-check-box style="color: #f38642" class="pl-4 ml-3 mb-2"
                [value]="model.customRedirection?.showButtonRedirection"
                (onValueChanged)="handleVisibleCustomButtonChange($event)" text="Mostrar botón personalizable">
              </dx-check-box>
              <legend *ngIf="model.customRedirection?.showButtonRedirection" class="pl-4  ml-3 mb-4">Botón
                personalizable de app </legend>

              <div class="block" *ngIf="model.customRedirection?.showButtonRedirection">
                <div class="d-flex">
                  <div class="col-5 pl-0">
                    <div class="block text-center d-flex flex-column align-items-center">
                      <small *ngIf="!customButtonImageValid" class="text-danger">
                        Este campo es obligatorio
                      </small>
                      <app-image-viewer [type]="'customRedirection'"
                        [base64customImage]="model.customRedirection?.image"></app-image-viewer>
                      <app-image-uploader [isStamp]="false" (imageSelected)="handleCustomButtonImageChange($event)">
                      </app-image-uploader>
                    </div>
                  </div>
                  <div class="col-7 pl-0">
                    <app-form-input-app [labelText]="'Nombre para mostrar'" [isRequired]="false">
                      <input class="form-control" autocomplete="off" type="text"
                        [ngModel]="model.customRedirection?.name" (ngModelChange)="handleCustomButtonNameChange($event)"
                        name="name" [ngClass]="{'invalid-field ': !customButtonNameValid}">
                      <small *ngIf="!customButtonNameValid" class="text-danger">
                        Este campo es obligatorio
                      </small>
                    </app-form-input-app>
                    <app-form-input-app [labelText]="'Url de redirección en Android'" [isRequired]="false">
                      <input class="form-control" autocomplete="off" type="text"
                        [ngModel]="model.customRedirection?.androidUrl"
                        (ngModelChange)="handleCustomButtonAndroidUrlChange($event)" name="androidUrl"
                        [ngClass]="{'invalid-field ': !customButtonAndroidUrlValid}">
                      <small *ngIf="!customButtonAndroidUrlValid" class="text-danger">
                        El enlace no es válido (https://xxxx o https://play.google.com/store/apps/details?id=xxx)
                      </small>
                    </app-form-input-app>
                    <app-form-input-app [labelText]="'Url de redirección en iOS'" [isRequired]="false">
                      <input class="form-control" autocomplete="off" type="text"
                        [ngModel]="model.customRedirection?.iosUrl"
                        (ngModelChange)="handleVisibleCustomIosUrlChange($event)" name="iosUrl">
                      <small *ngIf="!customButtonIosUrlValid" class="text-danger">
                        El enlace no es válido (https://xxxx o https://apps.apple.com/app/idxxxxxxxx)
                      </small>
                    </app-form-input-app>
                  </div>
                </div>

              </div>
            </div>

          </div>

        </div>

        <div class="col-sm-12 col-lg-6">
          <div class="row">
            <div class="col-12 "  *ngIf="livesHrLicence">
              <legend class="pl-0 mt-2">Mensajes de comunicación de correo electrónico</legend>
              <app-form-input-app [labelText]="'Texto notificación de solicitud aceptada'" [isRequired]="true"
                [length]="11">
                <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.mailAcceptText"
                  (ngModelChange)="setMailAccept($event)" name="MailNotificationAccepted" required maxlength="200">
              </app-form-input-app>
              <app-form-input-app [labelText]="'Texto notificación de solicitud rechazada'" [isRequired]="true"
                [length]="11">
                <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.mailDenyText"
                  (ngModelChange)="setMailReject($event)" name="MailNotificationRejected" required maxlength="200">
              </app-form-input-app>
            </div>

            <div class="col-12 d-flex flex-column justify-content-center mt-3 pt-4 ">

              <div class="row justify-content-sm-start">

                <div class="col-lg-5 p-0">
                  <div class="block text-center d-flex flex-column align-items-center">
                    <legend class="text-left ">Imagen de App</legend>
                    <app-image-viewer [base64Image]="model.imageData.base64FullData"
                      [type]="'image'"></app-image-viewer>
                    <app-image-uploader [isStamp]="false" (imageSelected)="handleImageSelected($event)">
                    </app-image-uploader>
                  </div>
                </div>

                <!-- 
                <div class="col-5">
                  <div class="block text-center d-flex flex-column align-items-center">
                    <legend class="pl-0">Firma Nómina</legend>
                    <app-image-viewer [type]="'stamp'"
                      [base64Stamp]="model.stampData.base64FullData"></app-image-viewer>
                    <app-image-uploader [isStamp]="true"
                      (stampSelected)="handleStampSelected($event)"></app-image-uploader>
                  </div>
                </div> -->
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Botonera -->
      <div class="row">
        <label class="col-md-3"></label>
        <div class="col-md-9">
          <div class="form-group form-button">
            <button class="btn btn-fill btn-primary float-right" type="submit"
              [disabled]="!textFieldsNotEmpty">Guardar</button>
            <a class="btn btn-fill btn-outline-white float-right" routerLink="../">Volver</a>
          </div>
        </div>
      </div>
    </form>

  </app-generic-panel>
</app-generic-container>